import _flatten from './_flatten.js';

// Flatten out an array, either recursively (by default), or up to `depth`.
// Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
export default function flatten(array, depth) {
  return _flatten(array, depth, false);
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/flatten.js
// module id = 1887
// module chunks = 1